import script from "./About_Us.vue?vue&type=script&setup=true&lang=js"
export * from "./About_Us.vue?vue&type=script&setup=true&lang=js"

import "./About_Us.vue?vue&type=style&index=0&id=51bb48e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51bb48e0"]])

export default __exports__